<div class="h-full flex flex-col">
  <!-- <div class="ml-2">
    <uni-breadcrumb></uni-breadcrumb>
  </div> -->
  <div class="flex grow min-h-0 gap-2 mt-3">
    <!-- COLLAPSIBLE SIDEBAR WRAPPER -->
    <div *ngIf="items.length" class="sidebar-wrapper" [class.collapsed]="isSidebarCollapsed">
      <!-- TOGGLE BUTTON WITH ARROW ICON -->
      <div class="sidebar-toggle" (click)="toggleSidebar()" [title]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
        <i class="pi" [class.pi-angle-left]="!isSidebarCollapsed" [class.pi-angle-right]="isSidebarCollapsed"></i>
      </div>
      <!-- SIDEBAR CONTAINER WITH MENU AND BUTTONS -->
      <div class="sidebar-container">
        <p-panelMenu styleClass="layout-submenu" [model]="items" [multiple]="true"></p-panelMenu>
        <button
          *ngIf="showPrintBarcodesButton"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-print"
          [disabled]="!canPrintBarcodes"
          (click)="printBarcodes()"
        >
          <span>Print Barcodes</span>
        </button>
        <button
          *ngIf="showAddInventoryButtons"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-plus"
          (click)="addBlankItemDetail()"
        >
          <span>Add Blank Item Detail</span>
        </button>
        <button
          *ngIf="showAddInventoryButtons"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-2"
          icon="pi pi-copy"
          (click)="copySelectedItemDetail()"
        >
          <span>Copy Selected Item Detail</span>
        </button>
        <button
          *ngIf="showEoqButtons"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-4"
          icon="pi pi-info-circle"
          [disabled]="!canShowFormula"
          (click)="showFormula()"
        >
          <span>Show Formula</span>
        </button>
        <button
          *ngIf="showEoqButtons"
          pButton
          type="button"
          class="p-button-raised p-button-sm mt-2"
          icon="pi pi-box"
          (click)="goProductTypes()"
        >
          <span>Go to Product Types</span>
        </button>
        <div *ngIf="showEoqButtons" class="flex justify-center items-center mt-8">
          <p-checkbox
            inputId="showPercentages"
            [ngModel]="showPercentages"
            (ngModelChange)="toggleShowPercentages()"
            name="showPercentagesCb"
            [binary]="true"
          ></p-checkbox>
          <label for="showPercentages" class="ml-2">Show Percentages</label>
        </div>
        <!-- Scanner control for Inventory Maintenance page -->
        <div *ngIf="showScannerControls" class="mt-8">
          <uni-scanner-input
            #scannerInput
            label="Scan Inventory ID..."
            busyLabel="Processing..."
            [disabled]="scannerDisabled"
            [searchFn]="scannerSearchFn"
            (scanResult)="onScannerResult($event)"
            (scanError)="onScannerError($event)"
          ></uni-scanner-input>
        </div>
      </div>
    </div>
    <!-- MAIN CONTENT AREA -->
    <div class="grow flex flex-col min-h-0 ml-4">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
